/* "Show More" for paginated product grids — appends the next page in place instead of navigating.
   Drives BOTH templates/collection.liquid AND templates/search.liquid: each wraps its grid in a
   paginate block and exposes the same [data-hl-grid] / [data-hl-loadmore] / [data-hl-count] hooks,
   so there is one implementation rather than two that can drift. Filename kept as hl-collection.js
   because renaming a live theme asset means deleting the old key; the scope is grids, not collections.

   PROGRESSIVE ENHANCEMENT, not a hard dependency. The button is a real <a href> pointing at
   paginate.next.url, so with this file blocked or broken the shopper still reaches page 2 by a
   normal navigation. Every failure path here falls back to that navigation rather than trapping
   them on a partial grid — the whole point of the fix is that all 162 products stay reachable.

   The SERVER stays the source of truth for "what comes next": after each fetch we read the next
   href and the count straight out of the returned HTML rather than incrementing a local counter.
   That way active filters/sort (which paginate.next.url encodes) can never drift out of step. */
(function () {
  'use strict';
  var grid = document.querySelector('[data-hl-grid]');
  var btn = document.querySelector('[data-hl-loadmore]');
  if (!grid || !btn) return;

  var busy = false;
  var countEl = document.querySelector('[data-hl-count]');
  var total = countEl ? parseInt(countEl.getAttribute('data-total'), 10) : 0;

  /* Which products are already on screen. Needed because SHOPIFY SEARCH REPEATS PRODUCTS ACROSS
     PAGES — verified 2026-07-30 by fetching /search?q=belly&type=product pages 1-3 straight from the
     server: 48+48+47 = 143 slots but only 136 distinct products, e.g. sally-fake-belly-piercing and
     glittery-butterfly-belly-ring each appeared on two pages. Search results are relevance-ordered
     and that order is not stable between paginated requests. Without this set the grid would visibly
     render the same product twice. Collections are stably ordered, so there it is simply a no-op. */
  var seen = Object.create(null);
  function keyOf(card) {
    var a = card.querySelector && card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }
  Array.prototype.forEach.call(grid.children, function (c) {
    var k = keyOf(c); if (k) seen[k] = true;
  });

  /* Count from what is actually IN the grid, not from the server's page arithmetic — after dedupe
     those two disagree. On the last page the total itself is unreliable (Shopify's 143 vs 136 real),
     so drop it and state the honest figure instead of implying items are missing. */
  function updateCount(hasMore) {
    if (!countEl) return;
    var n = grid.querySelectorAll('.pcard').length;
    countEl.textContent = hasMore && total > n
      ? 'Showing ' + n + ' of ' + total
      : 'Showing all ' + n;
  }

  btn.addEventListener('click', function (e) {
    var url = btn.getAttribute('href');
    if (!url) return;                     // nothing queued — let the browser do whatever it would
    e.preventDefault();
    if (busy) return;                     // guards a double-tap appending the same page twice
    busy = true;

    var label = btn.textContent;
    btn.textContent = 'Loading…';
    btn.setAttribute('aria-busy', 'true');

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-hl-grid] > *');
        if (!cards.length) throw new Error('no cards in response');

        var frag = document.createDocumentFragment();
        var added = 0;
        Array.prototype.forEach.call(cards, function (c) {
          var k = keyOf(c);
          if (k && seen[k]) return;              // already on screen — Shopify search repeat
          if (k) seen[k] = true;
          frag.appendChild(document.importNode(c, true));
          added++;
        });
        grid.appendChild(frag);

        var nextBtn = doc.querySelector('[data-hl-loadmore]');
        var nextHref = nextBtn && nextBtn.getAttribute('href');
        updateCount(!!nextHref);

        if (nextHref) {
          btn.setAttribute('href', nextHref);
          btn.textContent = label;
          /* Every card on that page was a duplicate, so the shopper saw nothing change. Keep
             walking rather than making them click again for another possibly-empty page. */
          if (added === 0) { busy = false; btn.click(); return; }
        } else {
          /* Last page reached — drop the control rather than leaving a dead button. */
          if (btn.parentNode) btn.parentNode.removeChild(btn);
        }
      })
      .catch(function () {
        /* Fail OPEN: a normal navigation still gets them to the products. */
        window.location.href = url;
      })
      .then(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
      });
  });
})();
